import { http, HttpResponse } from 'msw';
import { env } from '@repo/env';
import { getLoanMock } from './mocks/get-loan.mock';
var apiUrl = env.VITE_API_URL;
export var loanGetHandler = [
    http.get("".concat(apiUrl, "/loan/*"), function () {
        return HttpResponse.json(getLoanMock.successAgreedStage2);
    }),
];
